var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-btn",class:[
    `base-btn--${_vm.type}`,
    `base-btn--${_vm.size}`,
    { 'is-disabled': _vm.disabled, 'is-loading': _vm.loading }
  ],attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._v(" "),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',{class:{ 'ml-1': _vm.icon || _vm.loading }},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }